import axios from 'axios'

export default {
  name: 'jgcg',
  components: {},
  data () {
    return {
      jgcgList: [
        {
          name: '出版著作',
          dbCode: 'ZCCBZZ'
        },  {
          name: '展陈展览',
          dbCode: 'ZCZCZLK'
        },  {
          name: '学术论文',
          dbCode: 'ZCXSLW'
        },{
          name: '音频',
          dbCode: 'ZCYPJK'
        }, {
          name: '视频',
          dbCode: 'ZCSPJK'
        },{
          name: '学术会议',
          dbCode: 'ZCHYLW'
        },
      ],
      resultIp: 'http://files.travel-yuhuatai.com:82'
    }
  },
  // 创建元素
  mounted () {
  },
  // 方法定义
  methods: {
    // 点击前往详情
    goMore (item) {
      const url = this.resultIp + '/literature' + '?dbCode=' + item.dbCode
      window.open(url, '_blank')
    }
  }
}
